const INPUT = ["text", "email", "number", "password", "tel", "url"];

const BUTTON = ["submit", "button"];

const RADIOSELECT = ["radio", "checkbox"];

const OTHER = [
  ...RADIOSELECT,
  "autocomplete",
  "checkbox",
  "country",
  "currency",
  "date",
  "daterange",
  "file",
  "phone",
  "select",
  "switch",
  "textarea",
  "texteditor",
];

const SLOTS = ["errors", "help", "label", "remove", "addMore"];

function importComponent(type) {
  if ([...INPUT].includes(type)) {
    return import(`@/components/Form/Input.vue`);
  }

  if ([...BUTTON].includes(type)) {
    return import(`@/components/Form/Button.vue`);
  }

  return import(
    `@/components/Form/${type.charAt(0).toUpperCase() + type.slice(1)}.vue`
  );
}

export default {
  classes: {
    outer: "form-group",
  },
  library: {
    ...[...INPUT, ...BUTTON, ...OTHER].reduce(
      (objectType, type) => ({
        ...objectType,
        [type]: {
          component: () => importComponent(type),
          ...([...RADIOSELECT].includes(type) && { classification: type }),
        },
      }),
      {},
    ),
  },
  slotComponents: {
    ...[...SLOTS].reduce(
      (objectSlots, slotsType) => ({
        ...objectSlots,
        [slotsType]: () =>
          import(
            `@/components/Form/Slots/${
              slotsType.charAt(0).toUpperCase() + slotsType.slice(1)
            }.vue`
          ),
      }),
      {},
    ),
  },
};
